

export function getPasswordStrength(password) {
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  return score;
}

export function getInitials(name) {
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function getSessionProfileValues() {
  const firstName = sessionStorage.getItem("firstName") || "";
  const lastName = sessionStorage.getItem("lastName") || "";
  const sessionUserName = sessionStorage.getItem("userName") || "";
  const userId =
    sessionStorage.getItem("userId") ||
    sessionStorage.getItem("email") ||
    "";
  const role = sessionStorage.getItem("role") || "";
  const displayName =
    `${firstName} ${lastName}`.trim() || sessionUserName || "User";
  const email = sessionStorage.getItem("email") || "";
  const questionId = sessionStorage.getItem("questionId") || "";
  const securityAnswer = sessionStorage.getItem("securityAnswer") || "";

  return {
    firstName,
    lastName,
    displayName,
    email,
    userId,
    role,
    questionId,
    securityAnswer,
  };
}

/** Persists edited profile fields to sessionStorage (no backend endpoint exists for profile updates yet). */
export async function saveProfileToSession(values) {
  // Simulates a network round-trip until a real "update profile" endpoint is available.
  await new Promise((resolve) => setTimeout(resolve, 800));

  sessionStorage.setItem("firstName", values.firstName || "");
  sessionStorage.setItem("lastName", values.lastName || "");
  sessionStorage.setItem("userName", `${values.firstName || ""} ${values.lastName || ""}`.trim());
  sessionStorage.setItem("questionId", values.questionId || "");
  sessionStorage.setItem("securityAnswer", values.securityAnswer || "");
}
